var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceManIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11576",
    "data-name": "Group 11576",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.728,
    height: 16.731,
    viewBox: "0 0 16.728 16.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4188",
    "data-name": "Rectangle 4188",
    width: 16.728,
    height: 16.731,
    fill: "#0094d1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11575",
    "data-name": "Group 11575",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M8.519,0A8.366,8.366,0,1,1,0,8.068,8.351,8.351,0,0,1,8.519,0m7.019,8.36a7.171,7.171,0,1,0-7.111,7.174,7.155,7.155,0,0,0,7.111-7.174",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M39.058,24.384c0-.383,0-.75,0-1.117a.971.971,0,0,1,.067-.325.572.572,0,0,1,1.09.168c.017.366.015.733.02,1.1,0,.053,0,.105,0,.173h.114c.52,0,1.04,0,1.559,0a1.228,1.228,0,0,1,.285.037.572.572,0,0,1-.078,1.123,1.752,1.752,0,0,1-.25.019c-.5,0-1,0-1.5,0h-.119v1.807c.04,0,.079,0,.118,0,.345.01.69.008,1.034.035a2.048,2.048,0,0,1,1.81,2.116,2.005,2.005,0,0,1-.915,1.675,1.788,1.788,0,0,1-.939.327c-.326.013-.653.012-.979.017H40.24v.113c0,.339,0,.679,0,1.018a.632.632,0,0,1-.25.537.57.57,0,0,1-.907-.4c-.027-.371-.016-.745-.022-1.118,0-.046,0-.092,0-.148h-.12c-.529,0-1.058,0-1.587,0a.641.641,0,0,1-.561-.257.575.575,0,0,1,.4-.9,2.641,2.641,0,0,1,.3-.018c.482,0,.965,0,1.447,0h.117V28.554c-.043,0-.083,0-.122,0-.348-.011-.7,0-1.043-.037a1.923,1.923,0,0,1-1.249-.642,2,2,0,0,1-.55-1.275,2.062,2.062,0,0,1,1.786-2.178c.345-.038.7-.027,1.043-.038.043,0,.086,0,.142,0m-.005,1.186c-.037,0-.067,0-.1,0-.246,0-.491,0-.737,0a1.348,1.348,0,0,0-.267.032.892.892,0,0,0,.075,1.752c.275.023.552.016.829.022.064,0,.129,0,.2,0Zm1.192,4.774c.338,0,.672.025,1-.006a.887.887,0,0,0,.008-1.763c-.25-.02-.5-.015-.754-.021-.083,0-.166,0-.254,0Z",
    transform: "translate(-31.284 -19.597)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceManIcon);
export default __webpack_public_path__ + "static/media/price-man-icon.4e51755428666193ff372c7b370ed8bd.svg";
export { ForwardRef as ReactComponent };